import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Slideshow,
  GridLayout,
  HorizontalScroll,
  VerticalScroll,
  LightBox,
} from "../Utils/MediaViews";
import { FetchUserDataInSettings } from "../Utils/SettingsUserFetchMockData";
import { MediaDisplayContext } from "../../../../../context/MediaDisplayModeContext";

const MediaDisplay = () => {
  const { displayMode, setDisplayMode } = useContext(MediaDisplayContext);
  const [perProfileMode, setPerProfileMode] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [userid, setUserid] = useState("");
  const [updatedProfiles, setUpdatedProfiles] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const userData = await FetchUserDataInSettings();

      if (userData && Array.isArray(userData.profiles)) {
        // Assign UUID if missing (fallback)
        const profilesWithUUID = userData.profiles.map((profile, index) => ({
          profileUUID: profile.profileUUID || `uuid-${profile.profilename}-${index}`,
          ...profile,
        }));
        setUserid(userData.userId);
        setProfileData(profilesWithUUID);
      } else {
        console.warn("Profiles not found or userData is null.");
        setProfileData([]);
      }
    };
    fetchData();
  }, []);

  const handleProfileChange = (uuid, key, value) => {
    setUpdatedProfiles((prev) => ({
      ...prev,
      [uuid]: {
        ...prev[uuid],
        [key]: value,
      },
    }));
  };

  const handleSubmit = () => {
    const messages = profileData.map((profile) => {
      const uuid = profile.profileUUID;
      const updates = updatedProfiles[uuid] || {};

      const theme = updates.theme ?? profile.theme ?? "default";
      const mediaDisplayMode = updates.mediaDisplayMode ?? profile.mediaDisplayMode ?? "default";

      return `• ${profile.profilename}: Theme = "${theme}", Media Display = "${mediaDisplayMode}"`;
    });

    alert(`✅ Settings successfully updated for the following profiles:\n\n${messages.join("\n")}`);
  };

  const handleGoToProfiles = () => {
    navigate("/user-profiles/{userid}");
  };

  return (
    <div className="st-media-display-container" style={{ padding: 20 }}>
      <div>
        <p className="st-text-header" style={{fontSize: 30, marginTop: 30}}> Media Display Mode </p>
      </div>
      {/* GLOBAL DISPLAY MODE */}
      <div style={{display: "flex", flexDirection: "column"}}>
      <div className="media-preview" style={{ fontFamily: "Arial, Helvetica, sans-serif", fontSize: 20, marginTop: 30 }}>
        {displayMode === "slideshow" && <Slideshow />}
        {displayMode === "grid" && <GridLayout />}
        {displayMode === "horizontal-scroll" && <HorizontalScroll />}
        {displayMode === "vertical-scroll" && <VerticalScroll />}
        {displayMode === "lightbox" && <LightBox />}
      </div>

      <label htmlFor="media-view" className="st-dropdown-label" style={{ fontFamily: "Helvetica", fontSize: 18, color: "gray" }}>
        Choose Global Media Display Mode:
      </label>
      </div>
      <select
        id="media-view"
        value={displayMode}
        onChange={(e) => setDisplayMode(e.target.value)}
        style={{ marginLeft: 10, width: 400, background: "gray" }}
      >
        <option value="slideshow">Slideshow / Carousel</option>
        <option value="grid">Grid Layout</option>
        <option value="horizontal-scroll">Horizontal Scroll Gallery</option>
        <option value="vertical-scroll">Vertical Scroll Gallery</option>
        <option value="lightbox">Lightbox Viewing</option>
      </select>

      <div style={{ marginTop: 20 }}>
        <label style={{background: "none", color: "gray"}}>
          <input
            type="checkbox"
            checked={perProfileMode}
            onChange={(e) => setPerProfileMode(e.target.checked)}
            style={{ marginRight: 8, color: "gray" }}
          />
          Set Media Display Mode Per Profile
        </label>
      </div>

      {/* PER-PROFILE MEDIA MODE CUSTOMIZATION */}
        {perProfileMode && profileData.length > 0 && (
        <div style={{ marginTop: 20, background: "black", padding: 20, borderRadius: 10 }}>
          <p style={{ fontFamily: "arial", color: "gray", fontSize: 30 }}>Profile Media Display Settings</p>
          {profileData.map((profile) => {
            const uuid = profile.profileUUID;
            const changes = updatedProfiles[uuid] || {};

            return (
              <div
                key={uuid}
                style={{
                  width: 500,
                  padding: "10px 0",
                }}
              >
                <div>
                  <strong style={{ fontFamily: "arial", color: "gray" }}>{profile.profilename}</strong>
                </div>

                {/* Media Mode */}
                <div style={{ color: "gray" }}>
                  Current Media Mode: <span>{profile.mediaDisplayMode}</span>
                </div>

                <div style={{ marginTop: 8 }}>
                  <label style={{ marginRight: 10 }}>Set Media Display Mode:</label>
                  <select
                    value={changes.mediaDisplayMode ?? profile.mediaDisplayMode}
                    onChange={(e) =>
                      handleProfileChange(uuid, "mediaDisplayMode", e.target.value)
                    }
                    style={{ background: "gray", color: "white" }}
                  >
                    <option value="slideshow">Slideshow</option>
                    <option value="horizontal-scroll">Horizontal Scroll</option>
                    <option value="vertical-scroll">Vertical Scroll</option>
                    <option value="grid">Grid</option>
                    <option value="lightbox">Lightbox</option>
                  </select>
                </div>
              </div>
            );
          })}

          {/* ACTION BUTTONS */}
          <div style={{ display: "flex", gap: 20, marginTop: 20 }}>
            <button
              onClick={handleSubmit}
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              Submit Settings
            </button>

            <button
              onClick={handleGoToProfiles}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              Go to Profiles
            </button>
          </div>
        </div>
      )}
      <div>
      </div>
    </div>
  );
};

export default MediaDisplay;
